import Footer from '../Footer';

export default class BG extends Phaser.GameObjects.Container {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupBase();
        this.setupBGNew();
    }

    private setupBase(): void {
        const tint = 0x2b2437;
        const x = 0;
        const y = 10;
        const width = this.scene.cameras.main.width;
        const height = Footer.HEIGHT - y;

        const base = this.scene.add.rectangle(x, y, width, height, tint, 1);
        base.setOrigin(0);
        this.add(base);
    }

    private setupBGNew(): void {
        const x = 0;
        const y = 0;
        const width = this.scene.cameras.main.width;
        const frame = 'gui/footer/bg_new';

        const bgNew = this.scene.add.image(x, y, 'atlas', frame);
        bgNew.setOrigin(0);
        bgNew.displayWidth = width;
        bgNew.setInteractive();
        this.add(bgNew);
    }
}
